// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1bQYK","author":"Table_author__3gUYD","authorImage":"Table_authorImage__1ueZS","unreadRow":"Table_unreadRow__u4mG1"};